import { Grid } from "@mui/material";
import { useEffect } from "react";
import { Outlet } from "react-router";
import biApi from "../../../../../api/biApi";
import ReportsManager from "../../../reporting/report-lists/contexts/reports-manager/ReportsManager";
import { ReportsContextProvider } from "../../../reporting/report-lists/contexts/reports/ReportsContextProvider";
import { GroupsContextProvider } from "../../../reporting/report-lists/groups/contexts/GroupsContextProvider.tsx";
import useGroups from "../../../reporting/report-lists/groups/hooks/useGroups.ts";
import useReports from "../../../reporting/report-lists/hooks/useReports";
import {
  getEditApiReportUrl,
  getViewApiReportUrl,
} from "../../../reporting/report-lists/reports/utilities/editReportUrl";
import { BiApiClientProvider } from "../../../reporting/sv/contexts/BiApiClientProvider.tsx";
import type { BiApiClientBase } from "../../../reporting/sv/contexts/BiApiClientProviderContext.ts";

const ApiOrganizationReportsPage = () => {
  const { reports, ui, actions } = useReports(biApi.apiOrganizationReports.getOrganizationReports, "Api");
  const {
    groups,
    actions: groupActions,
    ui: groupsUi,
  } = useGroups({
    ...biApi.apiReportGroup,
    applyGroupSharing: actions.applyGroupSharing,
    getOrganizationReportGroups: biApi.apiOrganizationReports.getOrganizationReportGroups,
  });

  const { loadOrganizationGroups } = groupActions;
  useEffect(() => {
    loadOrganizationGroups();
  }, [loadOrganizationGroups]);

  return (
    <Grid container sx={{ flex: 1, width: "100%" }}>
      <BiApiClientProvider<BiApiClientBase>
        api={{
          validateName: biApi.apiReports.validateReportName,
          getReportSharing: biApi.apiReports.getReportSharing,
          updateReportSharing: biApi.apiReports.updateReportSharing,
          getEditReportUrl: getEditApiReportUrl,
          getViewReportUrl: getViewApiReportUrl,
        }}
      >
        <ReportsContextProvider reports={reports} ui={{ loaded: ui.loaded, error: ui.error }} actions={actions}>
          <GroupsContextProvider
            groups={groups}
            ui={groupsUi}
            actions={{ ...groupActions, reloadReports: actions.reloadReports }}
          >
            <ReportsManager
              onCopied={actions.reloadReports}
              onDeleted={actions.reloadReports}
              reports={reports}
              reportUsage={"Api"}
              openInNewTab={true}
            >
              <Outlet />
            </ReportsManager>
          </GroupsContextProvider>
        </ReportsContextProvider>
      </BiApiClientProvider>
    </Grid>
  );
};

export default ApiOrganizationReportsPage;
